<template>
    <div class="ds-settings-lunch-add">
        <div>
            <div class="text-xs text-gray">Продолжительность смены (мин.)</div>
            <div class="flex text-sm items-end text-gray">
                <div class="mr-1 pb-0.5">от</div><base-input class="w-20 mr-3" v-model="fromTime" :disabled></base-input>
                <div class="mr-1 pb-0.5">до</div><base-input v-model="shiftTime" max-length="5" class="w-20" type="number"
                @input="onChanges"></base-input>
            </div>
        </div>
        <div class="flex items-center"><base-input v-model="breakTime" max-length="5" @input="onChanges" type="number"
                class="w-24">Перерыв (мин.)</base-input></div>
        <button type="button" class="ds-settings-lunch-action" @click="add" :disabled="isDisabled"><icon><IconApprove /></icon></button>
        <button type="button" class="ds-settings-lunch-action ds-settings-lunch-action-danger" @click="onCancel"><icon><IconTrash /></icon></button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import IconTrash from '@/ui/icons/IconTrash.vue'
import IconApprove from '@/ui/icons/IconApprove.vue'
import debounce from 'lodash.debounce'

interface Lunch {
    id: string,
    shift_duration_seconds: string | number,
    break_duration_seconds: string | number
}

interface Props {
    lunches: Lunch[]
}

const { lunches } = defineProps<Props>()

const emit = defineEmits(['create', 'cancel'])

const isDisabled = ref(true)
const shiftTime = ref()
const breakTime = ref()
const fromTime = ref(0)
const disabled = true

if(lunches.length) {
    fromTime.value = +lunches[lunches.length-1]?.shift_duration_seconds/60
    shiftTime.value = fromTime.value + 60
}

const onChanges = debounce(() => {
    isDisabled.value = !(shiftTime.value && breakTime.value)
    if(shiftTime.value <= fromTime.value) shiftTime.value = fromTime.value + 1
    if(shiftTime.value <= 0) shiftTime.value = 1
}, 500) 

const add = () => {
    if(!isDisabled.value) {
        const data = {
        shift_duration_seconds: shiftTime.value * 60,
        break_duration_seconds: breakTime.value * 60
    }
        emit('create', data)
        isDisabled.value = true
    }
}

const onCancel = () => {
    shiftTime.value = ''
    breakTime.value = ''
    emit('cancel')
}
</script>
